/*
 * React 制御フォーム向け: Android 自動入力 / IME 未確定で state と DOM が
 * ずれる場合に、送信直前に input の実値を読む。
 */

/**
 * id で input を探し、blur 後の value を返す。見つからなければ fallback。
 * @param {string} inputId
 * @param {string} [fallback='']
 * @returns {string}
 */
export function readInputValueById(inputId, fallback = '') {
	const el = document.getElementById(inputId);
	if (!el) return fallback;
	el.blur();
	return typeof el.value === 'string' ? el.value : fallback;
}

/**
 * 複数 id の値をまとめて読む。
 * @param {Record<string, string>} idToFallback key=inputId, value=state のフォールバック
 * @returns {Record<string, string>}
 */
export function readInputValuesById(idToFallback) {
	const result = {};
	Object.keys(idToFallback).forEach((id) => {
		result[id] = readInputValueById(id, idToFallback[id]);
	});
	return result;
}
